import { render, staticRenderFns } from "./RankingList2.vue?vue&type=template&id=97df330e&scoped=true"
import script from "./RankingList2.vue?vue&type=script&lang=ts"
export * from "./RankingList2.vue?vue&type=script&lang=ts"
import style0 from "./RankingList2.vue?vue&type=style&index=0&id=97df330e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97df330e",
  null
  
)

export default component.exports